import { classAvatarSchema } from "./classAvatarSchema";

export const classAvatarsSchema = classAvatarSchema.array();
